import Axios from 'axios'
import { BASE_URL_PROD } from '../constants/url'
import { toast } from 'react-toastify'
import goto from './goto'

// 判断环境
const isProd = process.env.NODE_ENV === 'production'

// 获取token
const getToken = ()=>`Bearer ${localStorage.getItem('token')}`

const fetcher = Axios.create({
  baseURL: isProd ? BASE_URL_PROD+'/api' : '/api',
  timeout: 60000,
  headers: {
    'Authorization': getToken()
  }
})

fetcher.interceptors.request.use(config=>{
  config.headers['Authorization'] = getToken()

  return config
}, error=>{
  return Promise.reject(error)
})

// 全局返回处理
fetcher.interceptors.response.use(config=>{

  if(!config.data.success) {
    console.error( config.data.message, config.request )

    toast(config.data.message, {type: 'error'})

    if(config.data.errorCode === 402) { // 您的简历在筛选中，暂不能做心理测评 返回用户中心
      goto(-1)
    }

    if(config.data.errorCode === 401) { // 鉴权失效
      localStorage.setItem('token', '')
      localStorage.setItem('avatar', '')
      setTimeout(() => {
        goto('/', {state: {requireLogin: true}})
      }, 1000)
    }

  }
  if(config.status!==200) {
    return Promise.reject(config.data.message)
  }

  return config.data
}, error=>{
  return Promise.reject(error)
})

export default fetcher
